import { render, staticRenderFns } from "./side-menu.vue?vue&type=template&id=2ab98f56"
import script from "./side-menu.vue?vue&type=script&lang=ts"
export * from "./side-menu.vue?vue&type=script&lang=ts"
import style0 from "./side-menu.vue?vue&type=style&index=0&id=2ab98f56&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports